// src/components/FloatingTrustWidget.jsx
import React from 'react';
import { FaGoogle, FaStar } from 'react-icons/fa';
import '../styles/global.css'; // Uses styles added to global.css

const FloatingTrustWidget = () => {
  return (
    <a 
      href="https://share.google/Dc1CKaZaPgNbJmgzW"
      target="_blank"
      rel="noopener noreferrer"
      className="floating-trust-widget"
      aria-label="View Mahalakshmi Cabs on Google Business Profile"
    >
      <div className="widget-badge-logo">
        <FaGoogle />
      </div>
      <div className="widget-details">
        <div className="stars-row-widget">
          <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
        </div>
        <span className="rating-text-widget">4.9★ (180+ Reviews)</span>
      </div>
      <div className="widget-verified-check">✓</div>
    </a>
  );
};

export default FloatingTrustWidget;
